export default {
  Report: 'Báo cáo',
  DisplayHide: 'Ẩn hiện báo cáo',
  NotFavorite: 'Bạn chưa có báo cáo yêu thích.',
  ClickStar: 'Ấn vào hình sao bên cạnh báo cáo',
  ClickStarAfter: 'để thêm báo cáo vào mục yêu thích.',

  FavoriteReport: 'Báo cáo yêu thích',
  FinancialReport: 'Báo cáo tài chính',
  CivilEnforcementReport: 'Báo cáo nghiệp vụ thi hành án dân sự',
  GeneralLedger: 'Sổ cái',
  CashDepositReport: 'Tiền mặt, tiền gửi',
  AssetsReport: 'Tài sản, tang vật',
  OtherReport: 'Báo cáo khác',
  ReceiptReport: 'Báo cáo biên lai',

  SearchText: 'Tìm kiếm theo tên báo cáo',
  View: 'Xem',
  ReportTemplateWatermark: 'BÁO CÁO MẪU',
  FinancialStatementCompilation: 'Tổng hợp báo cáo tài chính'
};
